import { render, staticRenderFns } from "./Jobfair.vue?vue&type=template&id=7a07390c&scoped=true"
import script from "./Jobfair.vue?vue&type=script&lang=js"
export * from "./Jobfair.vue?vue&type=script&lang=js"
import style0 from "./Jobfair.vue?vue&type=style&index=0&id=7a07390c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a07390c",
  null
  
)

export default component.exports